import {
  RECEIVE_REGION_REPORT,
  FAILURE_REGION_REPORT,
  CLEAR_REGION_REPORT,
  REQUEST_VALIDATE_REGION,
  RECEIVE_VALIDATE_REGION,
  FAILURE_VALIDATE_REGION,
  RECEIVE_REGION_REPORT_APPLICATION_EVENT,
  FAILURE_REGION_REPORT_APPLICATION_EVENT,
  CLEAR_REGION_REPORT_APPLICATION_EVENT,
  REQUEST_REGION_REPORT,
  REQUEST_REGION_REPORT_APPLICATION_EVENT,
} from '../constants/actionTypes';

export const initialState = {
  isLoadingReport: false,
  isLoadingApplicationEvent: false,
  isValidatingRegion: false,
  isRegionValid: null,
  reportData: null,
  applicationEventData: null,
};

/**
 * Handles redux state for region report
 * @param {Object} state
 * @param {Object} action
 * @return {Object} new state
 */
function regionReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_REGION_REPORT: {
      return {
        ...state,
        isLoadingReport: true,
      };
    }
    case RECEIVE_REGION_REPORT: {
      return {
        ...state,
        isLoadingReport: false,
        reportData: action.payload,
      };
    }
    case FAILURE_REGION_REPORT: {
      return {
        ...state,
        isLoadingReport: false,
      };
    }
    case CLEAR_REGION_REPORT: {
      return initialState;
    }
    case REQUEST_REGION_REPORT_APPLICATION_EVENT: {
      return {
        ...state,
        isLoadingApplicationEvent: true,
      };
    }
    case RECEIVE_REGION_REPORT_APPLICATION_EVENT: {
      return {
        ...state,
        isLoadingApplicationEvent: false,
        applicationEventData: action.payload,
      };
    }
    case FAILURE_REGION_REPORT_APPLICATION_EVENT: {
      return {
        ...state,
        isLoadingApplicationEvent: false,
      };
    }
    case CLEAR_REGION_REPORT_APPLICATION_EVENT: {
      return {
        ...state,
        isLoadingApplicationEvent: false,
        applicationEventData: null,
      };
    }
    case REQUEST_VALIDATE_REGION: {
      return {
        ...state,
        isValidatingRegion: true,
      };
    }
    case RECEIVE_VALIDATE_REGION: {
      return {
        ...state,
        isValidatingRegion: false,
        isRegionValid: action.isRegionValid,
      };
    }
    case FAILURE_VALIDATE_REGION: {
      return {
        ...state,
        isValidatingRegion: false,
      };
    }
    default: {
      return state;
    }
  }
}

export default regionReducer;
